import { combineReducers } from "redux";
import { workflowFundListReducer } from "./WorkflowFundList/__redux/reducers";

export const workflowDashboardReducer = combineReducers({
	workflowFundList: workflowFundListReducer,
});
